import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { StripProduction } from './style';

const PANEL_PRODUCTION_GRADIENT = 'linear-gradient(90deg, #DE5B12 0%, #FFD159 89.5%)';

// Irradiance heatmap colours for the production strip. MUST match `_FLUX_STOPS`
// in solar-tool-api irradiance.py (stop positions there are over start → yellow;
// here they are over the whole strip, which ends at pale yellow).
// e.g. annual: dark purple at 200 or less, yellow at 1800, pale yellow at ~2257+.
const IRRADIANCE_GRADIENT = `linear-gradient(90deg, ${[
	'#2D0055 0%', // dark purple
	'#4C1F4A 3.1%', // plum
	'#712751 6.2%', // wine
	'#A80A69 9.3%', // dark magenta
	'#AF0F41 14%', // dark magenta-red
	'#CD2022 24.9%', // red-orange
	'#E64616 38.9%', // orange
	'#F2730A 56%', // bright orange
	'#FFD70A 77.8%', // lemon-gold yellow (annual 1800, monthly 200)
	'#FFEC96 100%', // pale yellow
].join(', ')})`;

// The strip under the canvas: panel-production colours, or the irradiance
// heatmap colours while the heatmap is on.
export default function ProductionLegend() {
	const { showIrradiance } = useSelector((state: RootState) => state.Irradiance.data);
	const gradient = showIrradiance ? IRRADIANCE_GRADIENT : PANEL_PRODUCTION_GRADIENT;

	return <StripProduction $gradient={gradient} />;
}
